import client from '@/api/client.js';
import store from "@/store";
//import i18n from '@/plugins/i18n.js'

export default {
    methods: {
        async updateContractDetailPrices(dto) {
            console.log("Updating contract detail prices with DTO:", dto);
            var meta = { clientApiMethod: 'updateContractDetailPrices', input: { dto: dto } }
            var response = await client().post(store.state.apiRouteRoot + "ContractDetail/UpdatePrices", dto, { meta: meta })
            return response?.data;
        },
        async getContractDetailListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getContractDetailListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "ContractDetail/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getContractDetailsWithLatestPriceFromFilter(filter, cancelationToken) {
            console.log("Fetching contract details with filter:", filter);
            var meta = { clientApiMethod: 'getContractDetailsWithLatestPriceFromFilter', input: { filter: filter } }
            var response = await client(true).get(store.state.apiRouteRoot + "ContractDetail/filtered-with-latest-price", {
                params: filter,
                signal: cancelationToken, meta: meta,
            })
            return response?.data;
        },

        async getContractLineTypes() {
            var meta = { clientApiMethod: 'getContractLineTypes', input: {} }
            var response = await client().get(store.state.apiRouteRoot + "ContractDetail/LineTypes", { meta: meta })
            return response?.data;
        },
        async getContractDetailById(contractDetailId) {
            var meta = { clientApiMethod: 'getContractDetailById', input: { contractDetailId: contractDetailId } }
            var response = await client().get(store.state.apiRouteRoot + "ContractDetail/" + contractDetailId, { meta: meta })
            return response?.data;
        },

        async createContractDetail(newContractDetail) {
            var meta = {
                clientApiMethod: 'createContractDetail',
                input: { newContractDetail },
                //successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.contract.contract") })
            }
            var response = await client().put(store.state.apiRouteRoot + 'ContractDetail', newContractDetail, { meta: meta })
            return response?.data;
        },

        async changeContractDetail(updatedContractDetail) {
            var meta = {
                clientApiMethod: 'changeContractDetail',
                input: { updatedContractDetail },
                //successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.contract.contract") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'ContractDetail', updatedContractDetail, { meta: meta })
            return response?.data;
        },

        async deleteContractDetail(contractDetailId) {
            var meta = {
                clientApiMethod: 'deleteContractDetail',
                input: { contractDetailId: contractDetailId },
                //successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.contract.contract") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "ContractDetail/" + contractDetailId, { meta: meta })
            return response?.data;
        },
    }
}